// import capitalize from './capitalize';

type ActiveUsers = {
  current: number;
  max: number;
  isOverflown: boolean;
  willOverflow(newActiveCount?: number): boolean;
  toString(): string;
};

export type ActiveUsersCount = Record<'editor' | 'viewer' | 'total', ActiveUsers>;

/**
 * Counts active users' info:
 *  current {number}: current active users by type
 *  max {number}: max active users of type
 *  isOverflown {() => boolean}: active users count is more than max
 *  willOverflow {() => boolean}: active users count will be more than max
 *  toString {() => string}: current/max string
 *
 * @param {License} license - License
 * @param {string} userType - type of user to count(editor | viewer)
 * @returns {ActiveUsers} - active users info
 */
export default (license: LicenseWithUsers, userType?: LicenseUser['type']): ActiveUsers => ({
  current: userType
    ? license.users.filter(({ status, type }) => status === 'active' && type === userType).length
    : license.users.filter(({ status }) => status === 'active').length,
  // max: userType
  //   ? license[`max${capitalize(userType)}s` as keyof License] as number
  //   : license.maxEditors + license.maxViewers,
  max: license.maxEditors + license.maxViewers,
  get isOverflown() {
    return this.current > this.max;
  },
  willOverflow(newActiveCount = 1) {
    return this.current + newActiveCount > this.max;
  },
  toString(): string {
    return `${this.current}/${this.max}`;
  },
});
